// for socket
export enum EventType {
    VOTE = 'VOTE',
    COMMENT = 'COMMENT',
}
